// extracted by mini-css-extract-plugin
module.exports = {"linkToggle":"LinkToggle_linkToggle__Irp3W","disableHoverEffect":"LinkToggle_disableHoverEffect__m7UK5","inactiveLink":"LinkToggle_inactiveLink__0XePO"};